import { useContext, useEffect } from "react";
import { CollapseContext } from "../Collapse";
import { DropdownContext } from "./Dropdown.context";
var DropdownFunctions = function () {
    var collapseContext = useContext(CollapseContext);
    var dropdownContext = useContext(DropdownContext);
    var onClickOutside = function (event) {
        if ((collapseContext === null || collapseContext === void 0 ? void 0 : collapseContext.expanded) &&
            (dropdownContext === null || dropdownContext === void 0 ? void 0 : dropdownContext.refButton) &&
            dropdownContext.refButton.current &&
            !dropdownContext.refButton.current.contains(event.target) &&
            (dropdownContext === null || dropdownContext === void 0 ? void 0 : dropdownContext.refContent) &&
            dropdownContext.refContent.current &&
            !dropdownContext.refContent.current.contains(event.target)) {
            collapseContext.closeCollapse();
        }
    };
    useEffect(function () {
        document.addEventListener("mousedown", onClickOutside);
        return function unmount() {
            document.removeEventListener("mousedown", onClickOutside);
        };
    }, [onClickOutside, dropdownContext === null || dropdownContext === void 0 ? void 0 : dropdownContext.refButton, dropdownContext === null || dropdownContext === void 0 ? void 0 : dropdownContext.refContent]);
    return null;
};
export default DropdownFunctions;
